/*!
=========================================================
* リスト型ViewのBase
=========================================================
*/
import React,{useRef, createRef} from "react";

import {
    Card, CardHeader, CardBody,
    Row, Col,
    FormGroup
} from "reactstrap";

import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import TitleWithBadge from '../FormParts/TitleWithBadge';
import CustomTable from '../ViewParts/CustomTable';

export default class ListBase extends React.Component {
    default_column = [];
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            add_url: undefined,
            search_url: '/',
            data: [],
            column: this.default_column,
            tmp_set: false,
            tmp_cnt: 0,
            with_all_check: false,
            detail_search: false,
            default_search: true,
            header_md:"6",
            show_detail_search_field: true,
            badge: true,
            defaultSortedColumn:[],
            checkbox_field_in_table:false,
            auto_scroll:false,
            displayLimitMessageFlag:1,
            display_flex:false,
        };
        this.searchWithPageIndex = this.searchWithPageIndex.bind(this)
        /* 2021/06/08 scroll to list top */
        this.contentRef = createRef();
        this.pageChangeHandle = this.pageChangeHandle.bind(this);
    }

    searchWithPageIndex(pageIndex = 0){
        this.setState({
            pageIndex
        })
        this.search()
    }

    dataMap(data) {
        return null;
    }

    validate() {
        return false;
    }

    search_params() {
        return {};
    }

    // 検索
    search() {
        /* ここは開発者が記述 */
        if (!this.validate()) {
            // do nothing
            return;
        }

        Request.get(this.state.search_url,this.search_params(), res => {
            this.setState({
                data: this.dataMap(res.data)
            });
        })
    }

    search_field_cols() {
        return (
            <>
            </>
        );
    }
    add_field_cols(){
        return (
            <>
            </>
        );
    }
    detail_search_field_btn(){
        return (<></>);
    }
    detail_search_field_cols(){
        return (<></>);
    }
    checkbox_field_cols(){
        return (<></>);
    }
    action_cols() {
        return (
            <>
            </>
        );
    }
    dialog_defines() {
        return (
            <>
            </>
        );
    }
    message_field_cols(){
        return (
            <>
            </>
        )
    }

    pageChangeHandle( customTable ){
        window.scrollTo(0,customTable.currentRef.current.offsetTop);
        return ;
    }

    render() {
        let search_field_cols = this.search_field_cols();
        let add_field_cols = this.add_field_cols();
        let detail_search_field_btn = this.detail_search_field_btn();
        let detail_search_field_cols = this.detail_search_field_cols();
        let checkbox_field_cols = this.checkbox_field_cols();
        let action_cols = this.action_cols();
        let dialog_defines = this.dialog_defines();
        let message_field_cols = this.message_field_cols();
        const {
            checkbox_field_in_table
        } = this.state
        console.log('listbase state', this.state.data)
        return (
            <>
                <div className="content" ref={this.contentRef}>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md="12" className="HEADER">
                                            <Card className="CardBottomNone">
                                                <CardHeader>
                                                    <Row>
                                                        <Col md={this.state.header_md?this.state.header_md:"6"}>
                                                            <TitleWithBadge label={this.state.title} badge={this.state.badge} count={this.props.new_arrivals_count[this.props.badge_key]} onclick={() => { this.setState({ tmp_set: !this.state.tmp_set }); }} />
                                                        </Col>
                                                        {this.state.add_url &&
                                                            <Col md="6">
                                                                <ButtonWithTooltip
                                                                    onclick={() => { this.props.history.push(this.state.add_url) }}
                                                                    class="float-right btn-search btn-facebook"
                                                                    id="tmp"
                                                                    icon="fas fa-plus"
                                                                    label="追加"
                                                                    message="データを追加"
                                                                />
                                                            </Col>
                                                        }
                                                        {add_field_cols}
                                                    </Row>
                                                    <Row>
                                                        <Col md="12" className="margin-auto">
                                                            <Card>
                                                                <CardBody className={"search-box " + (this.state.tmp_set ? 'on' : 'off')}>
                                                                　 {message_field_cols}
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </CardHeader>
                                                <CardBody>
                                                    <Row>
                                                        {search_field_cols}
                                                        {/*detail_search_field_btn*/}
                                                    </Row>
                                                    <Row>
                                                        <Col md="3">
                                                            <FormGroup>
                                                                <ButtonWithTooltip
                                                                    onclick={() => this.searchWithPageIndex(0)}
                                                                    class="btn-search"
                                                                    id="tmp"
                                                                    icon="fas fa-search"
                                                                    label="検索"
                                                                    message="検索を開始します。"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="textRight">
                                                    {action_cols}
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    {/*detail_search_field_cols*/}
                                    <CustomTable 
                                        page={this.state.pageIndex}
                                        handlePageUpdate={(pageIndex)=>this.setState({pageIndex})}
                                        checkbox_field_cols={checkbox_field_in_table?<Row>{checkbox_field_cols}</Row>:<></>}
                                        detail_search_field_cols={detail_search_field_cols}
                                        column={this.state.column}
                                        data={this.state.data}
                                        with_all_check={this.state.with_all_check}
                                        detail_search_field={this.state.show_detail_search_field}
                                        defaultSortedColumn={(this.state.defaultSortedColumn&&this.state.defaultSortedColumn.length>0)?this.state.defaultSortedColumn:undefined}
                                        page_id={this.props.page_id}
                                        checkedChangeCallback={(data)=>{
                                            this.setState({data:[...data]})
                                        }}
                                        /* 2021/06/08 scroll to list top */
                                        pageChangeFunc={(e)=>{
                                            if (this.state.auto_scroll) {this.pageChangeHandle(e)}}
                                        }
                                        displayLimitMessageFlag={this.state.displayLimitMessageFlag}
                                        display_flex={this.state.display_flex}
                                    />
                                    <Row>
                                    {checkbox_field_in_table?"":checkbox_field_cols}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                {dialog_defines}
            </>
        );
    }
}
